/**
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 */
export const REGEX_ASCII_WHITESPACE = /[\u0009\u000A\u000C\u000D\u0020]/;
